import { render, staticRenderFns } from "./ChangeInfo.vue?vue&type=template&id=154044b2&scoped=true"
import script from "./ChangeInfo.vue?vue&type=script&lang=js"
export * from "./ChangeInfo.vue?vue&type=script&lang=js"
import style0 from "./ChangeInfo.vue?vue&type=style&index=0&id=154044b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154044b2",
  null
  
)

export default component.exports